import { useQuery } from '@tanstack/react-query';
import { getSearchVisibility, type SearchVisibilityGranularity } from '../api/search-visibility';

export function useSearchVisibility(
  campaignId?: string,
  startDate?: string,
  endDate?: string,
  granularity?: SearchVisibilityGranularity,
) {
  return useQuery({
    queryKey: ['search-visibility', campaignId, startDate, endDate, granularity],
    queryFn: () => getSearchVisibility(campaignId, startDate, endDate, granularity),
    // The data changes once a night, so a slow refetch is plenty.
    refetchInterval: 600_000,
  });
}
